import React from "react";
import {
  Layout,
  Button,
  Tooltip,
  // Image
} from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { useAuth } from "../../../AuthContext";
import { getHeaderBarColor } from "../../../utils/getHeaderBarColor";

const { Header } = Layout;

const HeaderEstandar = ({ data }) => {
  const { setOpenMenu, cenope } = useAuth();
  const { headerTitle } = data;

  const barColor = getHeaderBarColor(headerTitle);

  return (
    <Header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingInline: "16px",
        zIndex: 100,
        position: "sticky",
        width: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <Button
          type="text"
          icon={
            <MenuOutlined
              className="custom-icon"
              style={{ fontSize: "26px", color: "white" }}
            />
          }
          onClick={() => setOpenMenu(true)}
        />

        {/* Barra vertical según módulo */}
        <div
          style={{
            width: "6px",
            height: "24px",
            backgroundColor: barColor,
            borderRadius: "2px",
          }}
        />

        {/* <Image preview={false} src="/Icono.svg" width={40} /> */}
        <div
          style={{
            color: "white",
            fontWeight: "bold",
            fontSize: "19px",
            whiteSpace: "nowrap",
          }}
        >
          {headerTitle}
        </div>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Tooltip title={cenope?.nombre} placement="left">
          <div
            style={{
              color: "white",
              fontSize: "15px",
              cursor: "pointer",
            }}
          >
            {cenope?.etique}
          </div>
        </Tooltip>
      </div>
    </Header>
  );
};

export default HeaderEstandar;
